import SignEvent from "../../../../src/events/2021/12/event-sign/main";
import * as React from 'react';
export default {
  SignEvent,
  React
};